import { CanvasElementType, CanvasFilterSettings, CanvasObjectPosition, CanvasObjectSize } from '@y42/json-schema';
import type { VisualizationFilterUIModel } from '../../filter/visualization-filter.model';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles } from './default-canvas-model-properties';

export const defaultFilterSize: CanvasObjectSize = {
  width: 400,
  height: 300,
};

export function getCanvasFilterModel(data: { position: CanvasObjectPosition; size: CanvasObjectSize }) {
  return {
    type: CanvasElementType.Filter,
    position: data.position,
    size: data.size,
    styles: {
      ...defaultCanvasGenericStyles,
      // Do not use `none` as it makes the rect element unselectable and breaks the color picker.
      'background-color': '#ffffff00',
      'border-color': '#ffffff00',
    },
    typeSettings: null,
  };
}

export interface CanvasFilterUISettings extends CanvasFilterSettings {
  filter?: VisualizationFilterUIModel;
}

export type CanvasFilterStoreModel = VisualizationCanvasElementStoreModel<CanvasElementType.Filter>;

export type CanvasFilterUIModel = CanvasFilterStoreModel & {
  typeSettings: CanvasFilterUISettings;
};
